<template>
  <div class="card gutter-b card-stretch">
    <!-- <div class="card-header h-auto border-0">
      <div class="card-title">
        <h3 class="card-label">
          <span class="d-block text-dark font-weight-bolder"
            >Weblog</span
          >
          <span class="d-block text-muted mt-2 font-size-sm"
            >More than 500+ new orders</span
          >
        </h3>
      </div>
    </div> -->
    <!-- <div class="card-body d-flex flex-column p-0"> -->
      
    <div class="table-responsive">
      <!-- Start of loading animation -->
      <div class="p-10" v-if="loading">
      <!-- <div class="card-body"> -->
      <div class="spinner spinner-primary spinner-md spinner-center"></div>
      <p class="text-6xl font-bold text-center text-gray-500 animate-pulse mt-5">
        Loading...
      </p>
      <!-- </div> -->
      <!-- End of loading animation -->
      <!-- Start of error alert -->
      <v-alert border="top" color="red lighten-2" v-if="error.length > 0" dark>
        {{ error.response }}
      </v-alert>
      </div>

      <vue-good-table  v-if="!loading"
        :columns="columns"
        :rows="data"
        styleClass="vgt-table /*striped*/"
        :fixed-header="false"
        compactMode
        :pagination-options="{
          enabled: false,
          perPage: 50,
          mode: 'pages'
        }"  
        :search-options="{
          enabled: false,
          placeholder: 'Search for a customer',
        }"
          @on-row-click="onRowClick">
        >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'diffDate'">
            <span v-if="props.row.diffDate == 0 && props.row.diffDate != ''" class="svg-icon"><i class="flaticon2-check-mark text-success"></i></span>
            <span v-if="props.row.diffDate == ''" class="svg-icon"><i class="flaticon-cancel text-warning"></i></span>
            <span v-if="props.row.diffDate != 0" class="text-muted font-weight-bold">{{ props.row.diffDate }}</span>
          </span>
          <span v-else>
            {{props.formattedRow[props.column.field]}}
          </span>
        </template>
      </vue-good-table>    
    </div>

      
    <!--begin::Table-->
      <!-- <table
        class="table table-head-custom table-vertical-center"
        id="kt_advance_table_widget_4"
      >
        <thead>
          <tr class="text-left">
            <th class="pl-0" style="width: 55px">Debnr</th>
            <th style="min-width: 140px">
              {{ $t("TRANSLATOR.NAME", { msg: "NAME" }) }}
            </th>
            <th class="pl-0" style="min-width: 50px; max-width: 80px">week</th>
            <th class="pr-0" style="min-width: 100px">Last connection</th>
            <th class="pr-0" style="min-width: 100px">Last buy</th>
            <th class="pl-0 text-right" style="min-width: 50px; max-width: 100px">Days</th>
            <th class="pl-0 text-right" style="min-width: 50px; max-width: 100px">Visited pages</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(item, i) in data">
            <tr v-bind:key="i">
              <td class="pl-0">
                  {{ item.debnr }}
              </td>
              <td>
                <a
                  v-bind:href="`#/customers/${item.debnr}`"
                  class="text-dark-75 font-weight-bolder text-hover-primary font-size-lg"
                >
                  {{ item.debnaam }}
                </a>
              </td>
              <td class="text-left">
                <span class="text-muted font-weight-bold">{{item.lastWeekVisit}}</span>
              </td>
              <td>
                <span class="text-muted font-size-sm">{{item.logtime}}</span>
              </td>
              <td>
                <span class="text-muted font-size-sm">{{item.lastBuy}}</span>
              </td>
              <td class="pr-0 text-right">
                <span v-if="item.diffDate == 0 && item.diffDate != ''" class="svg-icon"><i class="flaticon2-check-mark text-success"></i></span>
                <span v-if="item.diffDate == ''" class="svg-icon"><i class="flaticon-cancel text-warning"></i></span>
                <span v-if="item.diffDate != 0" class="text-muted font-weight-bold">{{ item.diffDate }}</span>
              </td>
              <td class="text-right">
                <span class="text-muted font-weight-bold">{{item.pages}}</span>
              </td>
              <td class="pr-0 text-right">
                <span class="label label-lg label-inline" v-bind:class="`label-light-${item.class}`">{{ item.status }}</span>
              </td> -->
            <!-- </tr>
          </template>
        </tbody>
      </table> -->
  </div>
</template>

<script>
import axios from "axios";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
// import MixedWidget1 from "@/view/content/widgets/mixed/Widget1.vue";
import 'vue-good-table/dist/vue-good-table.css'
import { VueGoodTable } from 'vue-good-table';


export default {
  // name: "line-base",
  components: {
    // MixedWidget1,
    VueGoodTable,
  },  
  data() {
    return {
      loading: true,
      error: [],
      data: [],
      columns: [
        {
          label: 'Debnr',
          field: 'debnr',
          thClass: 'text-muted font-size-sm',
          tdClass: 'text-hover-primary font-size-lg',
          width: '100px',
          filterOptions: {
          // styleClass: 'class1', // class to be added to the parent th element
            enabled: true, // enable filter for this column
            placeholder: 'Filter', // placeholder for filter input
            // filterValue: 'Jane', // initial populated value for this filter
            // filterDropdownItems: [], // dropdown (with selected values) instead of text input
            // filterFn: this.columnFilterFn, //custom filter function that
            // trigger: 'enter', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Name',
          field: 'debnaam',
          thClass: 'text-muted font-size-sm',
          tdClass: 'text-dark-75 font-weight-bolder text-hover-primary font-size-lg',
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: 'Week',
          field: 'lastWeekVisit',
          type: 'number',
          thClass: 'text-muted font-size-sm',
          tdClass: 'text-muted font-size-sm',
          width: '100px',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter', // placeholder for filter input
          },
        },
        {
          label: 'Last connection',
          field: 'logtime',
          sortable: false,
          thClass: 'text-muted font-size-sm',
          tdClass: 'text-muted font-size-sm',
          // type: 'date',
          // dateInputFormat: 'yyyy-MM-dd',
          // dateOutputFormat: 'MMM do yy',
        },
        {
          label: 'Last buy',
          field: 'lastBuy',
          sortable: false,
          thClass: 'text-muted font-size-sm',
          tdClass: 'text-muted font-size-sm',
        },
        {
          label: 'Days',
          field: 'diffDate',
          thClass: 'text-muted font-size-sm text-right',
          tdClass: 'text-muted font-size-sm text-right',
        },
        {
          label: 'Visited pages',
          field: 'pages',
          type: 'number',
          thClass: 'text-muted font-size-sm text-right',
          tdClass: 'text-muted font-size-sm text-right',
          formatFn: this.formatNumbers,
          // type: 'percentage',
        },
      ],
      // lineId: this.$route.params.id,
    }
  },
  mounted() {
    // console.log(this.$route.params);
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Home > Weblog"}]);
    // console.log(this.lineId);
    axios
      .get("/home/weblog")
      .then((response) => {
        this.data = response.data;
        this.loading = false;
      })
      .catch((error) => {
        this.error.response = "Error msg";
        // console.log(error.response)
        this.loading = false;
        throw error;
      });
  },
  methods: {
    formatNumbers: function(value) {
      return value.toLocaleString('nl-NL');
    },
    onRowClick(params){
      this.$router.push({ path: `/customer/${params.row.debnr}`});
    },
  },
};
</script>
